import isEmpty from "lodash/isEmpty";
import { PluginStore } from "graylog-web-plugin/plugin";
import VisualizationConfiguration from "./VisualizationConfiguration";
const findVisualizationType = (visualizationType) => {
  const visualizationTypeDefinition = PluginStore.exports("visualizationTypes").find(
    ({ type }) => type === visualizationType
  );
  if (!visualizationTypeDefinition) {
    throw new Error(`Invalid visualization type: ${visualizationType}`);
  }
  return visualizationTypeDefinition;
};
const defaultToConfig = () => void 0;
const formValuesToVisualizationConfig = (visualizationType, formValues) => {
  const { config: { toConfig: toConfig2 = defaultToConfig } = {} } = findVisualizationType(visualizationType);
  return toConfig2(formValues);
};
const defaultFromConfig = () => ({});
const visualizationConfigToFormValues = (visualizationType, config) => {
  const { config: { fromConfig: fromConfig2 = defaultFromConfig } = {} } = findVisualizationType(visualizationType);
  return fromConfig2(config);
};
const fromConfig = (config) => {
  var _a;
  return {
    visualization: {
      type: config.visualization,
      config: visualizationConfigToFormValues(config.visualization, config.visualizationConfig),
      eventAnnotation: (_a = config.eventAnnotation) != null ? _a : false
    }
  };
};
const toConfig = (formValues, configBuilder) => configBuilder.visualization(formValues.visualization.type).visualizationConfig(
  formValuesToVisualizationConfig(formValues.visualization.type, formValues.visualization.config)
).eventAnnotation(formValues.visualization.eventAnnotation);
const hasErrors = (errors) => Object.values(errors).filter((value) => value !== void 0).length > 0;
const validateConfig = (visualizationType, config) => {
  const { fields = [] } = visualizationType.config;
  return Object.fromEntries(
    fields.filter((field) => "required" in field && field.required).filter((field) => !field.isShown || field.isShown(config)).filter(({ name }) => config[name] === void 0 || config[name] === "").map(({ name, title }) => [name, `${title} is required.`])
  );
};
const validate = (formValues) => {
  var _a, _b;
  const {
    visualization: { type, config }
  } = formValues;
  if (!type) {
    return { "visualization.type": "Type is required." };
  }
  const visualizationType = findVisualizationType(type);
  const visualizationErrors = (_b = (_a = visualizationType.validate) == null ? void 0 : _a.call(visualizationType, formValues)) != null ? _b : {};
  const configErrors = visualizationType.config ? validateConfig(visualizationType, config) : {};
  return hasErrors(configErrors) || hasErrors(visualizationErrors) ? { visualization: { ...visualizationErrors, config: configErrors } } : {};
};
const VisualizationElement = {
  title: "Visualization",
  key: "visualization",
  order: 4,
  allowCreate: (formValues) => isEmpty(formValues.visualization),
  component: VisualizationConfiguration,
  fromConfig,
  toConfig,
  validate,
  isEmpty: () => false
};
export default VisualizationElement;
